import { Editor } from 'slate';
/**
 * Returns parent "list-item" node of "list-item" at a given path.
 * Returns null if there is no parent "list-item".
 */
export function getParentListItem(editor, path) {
  var parentListItem = Editor.above(editor, {
    at: path,
    match: node => editor.isListItemNode(node)
  });
  return parentListItem !== null && parentListItem !== void 0 ? parentListItem : null;
}